<template>
	<textarea
		class="h-full max-h-full focus:outline-none mb-4 text-base flex items-center w-full py-2.5 px-3.5 rounded border border-neutral-400 border-opacity-1 bg-white focus-within:ring-1 focus-within:!ring-primary focus-within:!border-primary"
		:class="{ 'bg-disabled': disabled, [inputClass ?? '']: true }"
		:name="name"
		:id="id"
		v-model="model"
		@input="emit('change')"
		@change="emit('change')"
	></textarea>
</template>

<script setup lang="ts">
defineProps<{
	id?: string;
	name?: string;
	disabled?: boolean;
	inputClass?: string;
}>();

// Loosely typed to match the untyped schema value the host binds via v-model.
const model = defineModel<any>();

const emit = defineEmits<{
	(e: "change"): void;
}>();
</script>
